import type { JSX } from "solid-js";

const RING = { green: "border-green", blue: "border-parking", violet: "border-violet" } as const;

/**
 * Icon + value. Vehicle sheet (Figma 03): the icon sits in a 36 px ring of its own colour
 * (battery green, distance blue, places violet). Without `ring`, a bare icon (ride screen).
 */
export function Stat(props: {
  icon: JSX.Element;
  value: string;
  label?: string;
  ring?: keyof typeof RING;
}) {
  return (
    <div class="flex items-center gap-2">
      {props.ring ? (
        <span
          class={`h-9 w-9 rounded-full border-2 flex items-center justify-center shrink-0 ${RING[props.ring]}`}
        >
          {props.icon}
        </span>
      ) : (
        <span class="flex items-center justify-center shrink-0">{props.icon}</span>
      )}
      <div class="leading-[1.25]">
        <div class="text-sm font-medium tracking-[0.14px] text-text">{props.value}</div>
        {props.label && <div class="text-xs text-text">{props.label}</div>}
      </div>
    </div>
  );
}
